import { render, staticRenderFns } from "./achieve.vue?vue&type=template&id=19295da4&scoped=true&"
import script from "./achieve.vue?vue&type=script&lang=js&"
export * from "./achieve.vue?vue&type=script&lang=js&"
import style0 from "./achieve.vue?vue&type=style&index=0&id=19295da4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19295da4",
  null
  
)

export default component.exports